import { Card } from "@mui/material";
import { ReactNode } from "react";

export type ObjectAttachmentCardProps = {
    attachmentID?: number;
    children?: ReactNode;
}

export function ObjectAttachmentCard({attachmentID, children}: ObjectAttachmentCardProps) {
    return (
        <Card data-itemid={attachmentID} variant="outlined">
            {children}
        </Card>
    )
}